import { useSelector } from 'react-redux';
import {
  makeSelectPerfilesUsuarioDatosPerfilesUsuarioSelected,
} from 'store/usuarios/selectors';

export const useCan = () => {
  const profileActive = useSelector(makeSelectPerfilesUsuarioDatosPerfilesUsuarioSelected());
  const perfil = String(profileActive?.ID_PERFIL ?? '');

  return {
    perfil,
    canSeePerfil: perfil !== '711' && perfil !== '611',
  };
};
